module.exports = __webpack_public_path__ + "img/ic24Car.59d6f60b.svg";